import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';


const routes: Routes = [
	{ path: '', redirectTo: '/home', pathMatch: 'full' },
  	{
		path: 'home',
		loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
	},
	{
		path: 'new-post',
		loadChildren: () => import('./shared/post-ad/post-ad.module').then(m => m.PostAdModule)
	},
	{
		path: 'post/:productId',
		loadChildren: () => import('./ad/ad.module').then(m => m.AdModule)
	},
	{
		path: 'chat',
		loadChildren: () => import('./chat/chat.module').then(m => m.ChatModule)
	},
	{
		path: 'user-account',
		loadChildren: () => import('./user-account/user-account.module').then(m => m.UserAccountModule)
	},
	{
		path: 'legal',
		loadChildren: () => import('./legal/legal.module').then(m => m.LegalModule)
	},
	{
		path: 'support',
		loadChildren: () => import('./support/support.module').then(m => m.SupportModule)
	},
	{
		path: 'verification',
		loadChildren: () => import('./verification/verification.module').then(m => m.VerificationModule)
	}
	// { path: '**', redirectTo: '/onnopathmatch', pathMatch: 'full' }
];

@NgModule({
	imports: [RouterModule.forRoot(routes), FormsModule],
	exports: [RouterModule]
})
export class AppRoutingModule { }
